import { Injectable } from "@angular/core";
import { GlobalConstants } from "src/app/constants";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import * as moment from "moment";
import { MenuUsers, MenuUsersAdapter } from "../Model/menu-users";

@Injectable({
  providedIn: "root",
})
export class MenuUsersService {
  private baseURL =
    GlobalConstants.BASE_API_URL + ":" + GlobalConstants.BASE_API_URL_PORT;
  private API_NAME = "menuUsers";

  constructor(
    private httpClient: HttpClient,
    private adapter: MenuUsersAdapter
  ) {}

  getAll(): Observable<MenuUsers[]> {
    const url = `${this.baseURL}/${this.API_NAME}/api/get/all`;
    return this.httpClient.get(url).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map((item) => this.adapter.adapt(item)))
    );
  }

  getAllGroupByUser(): Observable<MenuUsers[]> {
    const url = `${this.baseURL}/${this.API_NAME}/api/get/groupByUser`;
    return this.httpClient.get(url).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map((item) => this.adapter.adapt(item)))
    );
  }

  getAllGroupByMenu(): Observable<MenuUsers[]> {
    const url = `${this.baseURL}/${this.API_NAME}/api/get/groupByMenu`;
    return this.httpClient.get(url).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map((item) => this.adapter.adapt(item)))
    );
  }

  getAllByUser(user: string): Observable<MenuUsers[]> {
    const url = `${this.baseURL}/${this.API_NAME}/api/get/byUser`;
    const params = new HttpParams().set("user", user);
    return this.httpClient.get(url, { params }).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map((item) => this.adapter.adapt(item)))
    );
  }

  getAllByMenu(menu: string): Observable<MenuUsers[]> {
    const url = `${this.baseURL}/${this.API_NAME}/api/get/byMenu`;
    const params = new HttpParams().set("menu", menu);
    return this.httpClient.get(url, { params }).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map((item) => this.adapter.adapt(item)))
    );
  }

  checkForDuplicate(userID, id): Observable<MenuUsers[]> {
    // If id is <> null, then it is an update and need to make sure
    // not checking for a duplicate on it's on record ID, else
    // check without ID on a create
    if (id != null) {
      const url = `${this.baseURL}/${this.API_NAME}/api/check/duplicate`;
      const params = new HttpParams().set("userID", userID).set("id", id);
      return this.httpClient.get(url, { params }).pipe(
        // Adapt each item in the raw data array
        map((data: any[]) =>
          data["data"].map((item) => this.adapter.adapt(item))
        )
      );
    } else {
      // Creation duplicate check, since no ID.  No need to check by ID
      const url = `${this.baseURL}/${this.API_NAME}/api/get/byUserID`;
      const params = new HttpParams().set("userID", userID);
      return this.httpClient.get(url, { params }).pipe(
        // Adapt each item in the raw data array
        map((data: any[]) =>
          data["data"].map((item) => this.adapter.adapt(item))
        )
      );
    }
  }

  update(formData) {
    // Format lastUpdated to IBM i standards
    formData.lastUpdated = moment().format("YYYY-MM-DD-HH.mm.ss");
    formData.changeID = localStorage.getItem("user");
    const url = `${this.baseURL}/${this.API_NAME}/api/update`;
    return this.httpClient.post(url, formData);
  }

  deleteById(id) {
    const url = `${this.baseURL}/${this.API_NAME}/api/delete/byId`;
    return this.httpClient.post(url, { id: id });
  }

  deleteByUser(user) {
    const url = `${this.baseURL}/${this.API_NAME}/api/delete/byUser`;
    return this.httpClient.post(url, { user: user });
  }

  deleteByMenu(menu) {
    const url = `${this.baseURL}/${this.API_NAME}/api/delete/byMenu`;
    return this.httpClient.post(url, { menu: menu });
  }

  create(formData) {
    formData.changeID = localStorage.getItem("user");
    const url = `${this.baseURL}/${this.API_NAME}/api/create`;
    return this.httpClient.post(url, formData);
  }

  copy(formData) {
    formData.byUser = localStorage.getItem("user");
    const url = `${this.baseURL}/${this.API_NAME}/api/copy/user`;
    return this.httpClient.post(url, formData);
  }
}
